import { ModeOfDataInBlock, BlockStatus } from './utils';
/** Read the block header (28B) and body */
export class Block {
    constructor(buffer, fileHeader, offset) {
        /* set offset if defined */
        if (offset)
            buffer.offset = offset;
        this.scale = buffer.readInt16();
        this.status = new BlockStatus(buffer.readInt16());
        this.index = buffer.readInt16();
        this.mode = new ModeOfDataInBlock(buffer.readInt16());
        this.ctCount = buffer.readInt32();
        this.lpVal = buffer.readFloat32();
        this.rpVal = buffer.readFloat32();
        this.lvl = buffer.readFloat32();
        this.tlt = buffer.readFloat32();
        this.data = getBlockBody(buffer, fileHeader);
    }
}
/**
 * Parses the particular block of data  using file header information
 * @param buffer - IOBuffer with the data.
 * @param fileHeader - file header information.
 * @return array of block or single block
 */
export function getBlockBody(buffer, fileHeader) {
    //body data has just one element if `nTraces===1`
    const { np, nTraces, status: { isFloat32, isInt32 }, } = fileHeader;
    if (isFloat32) {
        //array is overwritten for each trace
        return dataReader(buffer, nTraces, np, 'readFloat32');
    }
    else if (isInt32) {
        //array is overwritten for each trace
        return dataReader(buffer, nTraces, np, 'readInt32');
    }
    else {
        //int16
        return dataReader(buffer, nTraces, np, 'readInt16');
    }
}
/**
 * reduces code duplication
 * @param buffer, the data
 * @param nTraces - number of fids
 * @param np - number of points: real + imaginary
 * @param readType - to select from IOBuffer
 */
function dataReader(buffer, nTraces, np, readType) {
    let fids = [];
    let fid;
    if (readType === 'readFloat32') {
        fid = { re: new Float32Array(np / 2), im: new Float32Array(np / 2) };
    }
    else if (readType === 'readInt32') {
        fid = { re: new Int32Array(np / 2), im: new Int32Array(np / 2) };
    }
    else {
        fid = { re: new Int16Array(np / 2), im: new Int16Array(np / 2) };
    }
    //`data` array is overwritten internally for each trace, as they all have same number of
    // datapoints np/2, then we define it only once
    for (let t = 0; t < nTraces; t++) {
        for (let i = 0; i < np; i += 2) {
            fid.re[i >>> 1] = buffer[readType]();
            fid.im[i >>> 1] = buffer[readType]();
        }
        fids[t] = fid;
    }
    return fids;
}
//# sourceMappingURL=readBlock.js.map